import { Input } from '@/components/wm';
import { cn } from '@/utils';
import { Search } from 'lucide-react';
import * as React from 'react';

const SearchInput = React.forwardRef(({ className, inputClassName, value, onChange, ...props }, ref) => {
    return (
        <div className={cn('tw-relative tw-w-full tw-items-center', className)}>
            <div className="tw-relative">
                <Search className="tw-absolute tw-left-2 tw-top-3 tw-h-4 tw-w-4 tw-text-muted-foreground"/>
                <Input
                    {...props}
                    className={cn('tw-pl-8 tw-bg-transparent', inputClassName)}
                    onChange={onChange}
                    placeholder={ props.placeholder || i18next.t('glossary.search').capitalize()}
                    ref={ref}
                    value={value}
                />
            </div>
        </div>
    );
});

SearchInput.displayName = 'SearchInput';

export { SearchInput };
